import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style.ts';

const feeRows = [
	{ name: '종신회원', fee: 'membership.guide.fees.lifetime', note: 'membership.guide.notes.adminManagedLifetime' },
	{ name: '이사회원', fee: 'membership.guide.fees.board', note: 'membership.guide.notes.adminManaged' },
	{ name: '정회원', fee: 'membership.guide.fees.regular', note: 'membership.guide.notes.selectOnAnnualFeePayment' },
	{ name: '학생회원', fee: 'membership.guide.fees.student', note: 'membership.guide.notes.selectOnAnnualFeePayment' },
];

const MembershipGuide = () => {
	const { t } = useTranslation();

	return (
		<S.Container>
			<S.SectionTitle id="membership-guide-title">{t('가입안내')}</S.SectionTitle>
			<S.ContentBox>
				<S.NoticeBox>
					<S.NoticeTitle>{t('membership.guide.noticeTitle')}</S.NoticeTitle>
					<S.NoticeDescription>{t('membership.guide.noticeDescription')}</S.NoticeDescription>
				</S.NoticeBox>

				<S.TablePanel>
				<S.Table className="table3 membership-fee-table" role="table" aria-label={t('membership.guide.feeTableLabel')}>
					<S.TableHeadCell className="center">{t('common.memberName')}</S.TableHeadCell>
					<S.TableHeadCell className="center">{t('common.annualFee')}</S.TableHeadCell>
					<S.TableHeadCell className="center">{t('common.notes')}</S.TableHeadCell>
					{feeRows.map((row) => (
						<RenderRow key={row.name} row={row} />
					))}
				</S.Table>
				</S.TablePanel>

				<S.GuideBox>
					<S.GuideTextStrong>{t('membership.guide.memberTypePolicyTitle')}</S.GuideTextStrong>
					<S.GuideText>{t('membership.guide.memberTypePolicyLine1')}</S.GuideText>
					<S.GuideText>{t('membership.guide.memberTypePolicyLine2')}</S.GuideText>
				</S.GuideBox>

				{/* <S.CenterNotice>가입비(연회비)는 아래의 농협은행 계좌번호로 입금하여 주시면 입금확인 즉시 학회지와 학회관련 자료를 송부해 드리겠습니다.</S.CenterNotice> */}

				{/* <S.InfoGrid>
				<S.InfoCard>
					<S.InfoTitle>계좌번호</S.InfoTitle>
					<S.InfoText>농협은행 : 301-0122-6751-81</S.InfoText>
					<S.InfoText>예금주 : 사단법인 한국응용과학기술학회</S.InfoText>
				</S.InfoCard>
				<S.InfoCard>
					<S.InfoTitle>기타 문의 사항</S.InfoTitle>
					<S.InfoText>[35349]대전 서구 도안북로 88, 목원대학교, C관 106호</S.InfoText>
					<S.InfoText>한국응용과학기술학회 사무국 전화 : 042-829-7578</S.InfoText>
					<S.InfoText>E-mail : ksast2023@naver.com</S.InfoText>
				</S.InfoCard>
			</S.InfoGrid> */}
			</S.ContentBox>
		</S.Container>
	);
};

const RenderRow = ({ row }: { row: (typeof feeRows)[number] }) => {
	const { t } = useTranslation();

	return (
		<Fragment>
			<S.TableCell className="center min-height">{t(row.name)}</S.TableCell>
			<S.TableCell className="center min-height">{t(row.fee)}</S.TableCell>
			<S.TableCell className="center min-height">{t(row.note)}</S.TableCell>
		</Fragment>
	);
};

export default MembershipGuide;
